import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {API_URLS, CrudEndpoints} from "@/utils/constants/api-urls.ts";
import {AfterFetchContext, MaybeRefOrGetter, UseFetchOptions} from "@vueuse/core";
import {IExam, IGetResult, IGroup, QueryFilter} from "@/types/api.ts";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {computed, toValue} from "vue";

export abstract class BaseService<ISchema> {

  abstract endpoints: CrudEndpoints<ISchema>

  async createNew<T>(body: Partial<T>): Promise<ISchema> {
    const {execute, data} = useAxios<IGetResult>(this.endpoints.create, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }

  list(query?: MaybeRefOrGetter<QueryFilter<ISchema>>, options?: UseFetchOptions) {
    const url = computed<string>(() => {
      let s = this.endpoints.list(toValue(query));
      return s
    });
    return useFactoryFetch(url, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.data}
      },
      ...options
    }).json<IExam[]>();
  }

  async deleteGroup(group: IGroup) {
    const {execute} = useAxios<IGetResult>(API_URLS.groups.deleteById(group._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }

}